(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('phoneInputGuard', phoneInputGuard);

    /**
     * Impede caracteres inválidos em campos de telefone com intl-tel-input e reaplica a
     * formatação da lib ao sair do campo. O valor do model continua sendo o de getNumber().
     */
    function phoneInputGuard() {
        var INVALID_CHARS = /[^0-9+()\-.\s]/g;
        var VALID_CHAR = /[0-9+()\-.\s]/;

        return {
            restrict: 'A',
            link: {
                pre: function(scope, element) {
                    element.on('keypress', function(event) {
                        var isPrintable = event.key && event.key.length === 1;
                        var hasModifier = event.ctrlKey || event.metaKey;
                        var isInvalidChar = isPrintable && !hasModifier && !VALID_CHAR.test(event.key);
                        if (isInvalidChar) {
                            event.preventDefault();
                        }
                    });

                    element.on('input', function() {
                        var input = element[0];
                        var current = input.value;
                        var cleaned = current.replace(INVALID_CHARS, '');
                        if (cleaned !== current) {
                            var caret = input.selectionStart;
                            var removedBeforeCaret = current.slice(0, caret).length - current.slice(0, caret).replace(INVALID_CHARS, '').length;
                            input.value = cleaned;
                            input.setSelectionRange(caret - removedBeforeCaret, caret - removedBeforeCaret);
                        }
                    });

                    element.on('blur', function() {
                        var hasPlugin = angular.isFunction(element.intlTelInput);
                        if (hasPlugin && element.val()) {
                            element.intlTelInput('setNumber', element.intlTelInput('getNumber'));
                        }
                    });
                }
            }
        };
    }
})();
